module.exports = __webpack_public_path__ + "img/qr.5f89b197.jpeg";